// This file explicitly lists the code splitting points for webpack.
//
// Unfortunately, we cannot intelligently create these strings (webpack isn't that smart)
//
// Current language keys:
// ar,ca,de,es,fi,fr,it,ja,ko,nl,pl,ru,sv,zh-CN,zh-TW
//
// EXCLUDE ENGLISH, it's included in the main flatpickr script

export default function(lang) {
    let asset;

    switch (lang) {
    case 'ar':
        asset = System.import('flatpickr/dist/l10n/ar.js');
        break;
    case 'ca':
        asset = System.import('flatpickr/dist/l10n/cat.js');
        break;
    case 'de':
        asset = System.import('flatpickr/dist/l10n/de.js');
        break;
    case 'es':
        asset = System.import('flatpickr/dist/l10n/es.js');
        break;
    case 'fi':
        asset = System.import('flatpickr/dist/l10n/fi.js');
        break;
    case 'fr':
        asset = System.import('flatpickr/dist/l10n/fr.js');
        break;
    case 'it':
        asset = System.import('flatpickr/dist/l10n/it.js');
        break;
    case 'ja':
        asset = System.import('flatpickr/dist/l10n/ja.js');
        break;
    case 'ko':
        asset = System.import('flatpickr/dist/l10n/ko.js');
        break;
    case 'nl':
        asset = System.import('flatpickr/dist/l10n/nl.js');
        break;
    case 'pl':
        asset = System.import('flatpickr/dist/l10n/pl.js');
        break;
    case 'ru':
        asset = System.import('flatpickr/dist/l10n/ru.js');
        break;
    case 'sv':
        asset = System.import('flatpickr/dist/l10n/sv.js');
        break;
    case 'zh-CN':
        asset = System.import('flatpickr/dist/l10n/zh.js');
        break;
    case 'zh-TW':
        asset = System.import('flatpickr/dist/l10n/zh.js');
        break;
    default:
        asset = false;
    }

    return asset;
}



// WEBPACK FOOTER //
// ./src/app/flatpickrTranslationAssets.js